<template>
  <div>
    <h1>Визиты сегодня :</h1>
    <div class="col-4 m-2">
      <b-form-group
        label="Поиск"
        label-for="filter-input"
        label-align-sm="right"
        label-size="sm"
        class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-input
            id="filter-input"
            v-model="filter"
            type="search"
            placeholder="Введите текст для поиска"
          ></b-form-input>

          <b-input-group-append>
            <b-button class="ms-3" :disabled="!filter" @click="filter = ''"
              >Очистить</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>
    <b-table
      striped
      hover
      :items="renderTable()"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      show-empty
      :filter="filter"
    ></b-table>
  </div>
</template>

<script>
import moment from "moment";

const axios = require("axios");
import { mapActions } from "vuex";

export default {
  name: "Visits",
  data: function () {
    return {
      visits: [],
      sortBy: "Время",
      sortDesc: true,
      filter: null,
      fields: ["Время", "Клиент", "Карта/Услуга", "Клуб", "Админ"],
    };
  },
  async mounted() {
    await this.fetchVisits();
    console.log(this.visits);
  },
  methods: {
    ...mapActions(["logOutUser"]),
    async fetchVisits() {
      const config = {
        headers: {
          Authorization: `Bearer ${this.$cookie.get("access_token")}`,
        },
      };
      this.visits = await axios
        .get(`${process.env.VUE_APP_API}/visits/all`, config)
        .then((response) => {
          return response.data.Visits.reverse();
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.logOutUser();
          }
        });
    },
    renderTable() {
      let options = [];
      this.visits.forEach((visit) => {
        options.push({
          Время: moment(visit.time).locale("ru").format("DD MMMM YYYY HH:mm"),
          Клиент: visit.client
            ? visit.client.name + " " + visit.client.surname
            : "Гость",
          Клуб: this.clubSort(visit.location_id),
          Админ: visit.admin.name + " " + visit.admin.surname,
          "Карта/Услуга": visit.group
            ? visit.group.name
            : visit.card
              ? visit.card.product.name
              : visit.training.name,
        });
      });
      return options;
    },
    clubSort: function (club) {
      if (Number(club === 1)) {
        return "Василенко, 9";
      } else if (club === 2) {
        return "Острожского, 55";
      }
    },
  },
};
</script>

<style scoped></style>
